import React from 'react';


const verifyOtpContext = React.createContext({
  sendOtpCallback: () => {},
  verifyOtpCallback: () => {},
  handleCallBackAfterVerification: () => {},
  callback: () => {},
  values: {},
  showSnackBar: false,
  setSnackBar: () => {},
  snackBarMsg: '',
  apiSuccess: false,
  setIsVerifyOtpVisible: () => {},
  verifyRetryLeft: true,
  verificationSuccess: false,
  isOtpVerificationRequired: false,
  isVerifyOtpVisible: false,
  setIsOtpVerificationRequired: (required:boolean) => {},
});

const { Provider, Consumer } = verifyOtpContext;

export const VerifyOtpContextProvider = Provider;

export const VerifyOtpContextConsumer = Consumer;

export const VerifyOtpContext = verifyOtpContext;
